import { map } from 'rxjs/operators';
import webApi from '../../../Lib/WebApi';
import { callApi } from '../../Helpers/rxjsHelpers';
import { Guid } from 'Lib/Guid';
import { LoadIncrementModel } from './types';

export const callApiAutoCreateLoadIncrements = (worksheetId: Guid) => {
  return callApi(webApi.soil.plateLoadingTests.autoCreateIncrements.get({ worksheetId })).pipe(
    map((response) => response.Body)
  );
};

export const callApiPutLoadIncrements = (worksheetId: Guid, loadIncrements: LoadIncrementModel[]) => {
  return callApi(
    webApi.soil.plateLoadingTests.loadIncrements.put(
      { Body: { Id: worksheetId, LoadIncrements: loadIncrements } },
      { worksheetId }
    )
  ).pipe(map((r) => r.Body));
};
